import {
  BEFORE_JULY_1_2013,
  ON_OR_AFTER_JULY_1_2016,
  SAVINGS_CHOICE,
  DESIGNATED_FACULTY,
  STAFF_OTHER_ACADEMIC_APPOINTEE,
  YES,
  NO
} from './constants/menuOptions.js';

// this gets set during loading by the App.js component
let RATES_DATA = null;

export const setRatesData = data => RATES_DATA = data;

export const getResults = formData => {
  if (!RATES_DATA) {
    throw new Error('rates data not loaded');
  }

  const {
    salary,
    med_plan,
    med_cov,
    dental_plan,
    dental_cov,
  } = formData;

  const payband = getPayband(salary);

  return {
    medicalInsurance:  getMedicalOrDentalInsurance(med_plan, med_cov, payband),
    dentalInsurance:  getMedicalOrDentalInsurance(dental_plan, dental_cov, payband),
    primaryRetirementBenefit: getRetirement(formData),
    socialSecurity: getSocialSecurity(salary),
    ...getVisionLifeAndDisablilityInsurance()
  };

};

//////////////////////
// HELPER FUNCTIONS //
//////////////////////
const getVisionLifeAndDisablilityInsurance = () => {
  const {
    VISION_SERVICES_PLAN,
    LIFE_INSURANCE,
    DISABILITY_INSURANCE
  } = RATES_DATA.FIXED_RATES;

  const vision = 12 * VISION_SERVICES_PLAN;
  const life = 12 * LIFE_INSURANCE;
  const disability = 12 * DISABILITY_INSURANCE;

  return {
    visionInsurance: { UC: vision, employee: 0 },
    ucPaidLifeInsurance: { UC: life, employee: 0 },
    ucPaidDisablityInsurance: { UC: disability, employee: 0 },
  };
};

const getSocialSecurity = salary => {
  const {
    SSI_MAX_WAGE,
    SSI_PERCENT,
    MEDICARE_PERCENT
  } = RATES_DATA.FED;
  const ssiWage = Math.min(SSI_MAX_WAGE, salary);

  const socialSecurity = (SSI_PERCENT * ssiWage / 100) + (salary * MEDICARE_PERCENT / 100);

  return {
    UC: socialSecurity,
    employee: socialSecurity
  };
};

const getRetirement = formData => {
  const {
    hired_date_tier,
    salary,
    lblRehired,
    hiredBeforeDate,
    pension_choice,
    pension_choice_elig
  } = formData;

  const {
    PEPRA_MAX,
    UC_SALARY_MAX
  } = RATES_DATA;

  const retirementRateEmployee = (hired_date_tier === BEFORE_JULY_1_2013) ? 8 : 7;
  const retirementRateUC = (pension_choice === SAVINGS_CHOICE) ? 8: RATES_DATA.RETIREMENT_RATE_UC[hired_date_tier];

  let eligibleSalaryRetirement = Math.min(salary, UC_SALARY_MAX);
  let dcSupplementalEmployee = 0;
  let dcSupplementalUC = 0;

  if (isSubjectToPepra(hired_date_tier, lblRehired, hiredBeforeDate, pension_choice)) {
    eligibleSalaryRetirement = Math.min(salary, PEPRA_MAX);
    let dcEligibleSalary = Math.min(salary, UC_SALARY_MAX);
    let dcRateEmployee = 7;

    const dcRateUC = (pension_choice_elig === DESIGNATED_FACULTY) ? 5 : 3;

    if (dcEligibleSalary > PEPRA_MAX) {
      // Employee Contribution: 7% on Eligible Pay of $118,775-$270K
      dcSupplementalEmployee = dcRateEmployee * (dcEligibleSalary - PEPRA_MAX) / 100;

      if (pension_choice_elig === STAFF_OTHER_ACADEMIC_APPOINTEE) {
        // UC Contribution: 3% on Eligible Pay of $118,775-$270K
        dcSupplementalUC = dcRateUC * (dcEligibleSalary - PEPRA_MAX) / 100;
      }
    }

    if (pension_choice_elig === DESIGNATED_FACULTY) {
      // UC Contribution: 5% on Eligible Pay of $0-$270K
      dcSupplementalUC = dcRateUC * dcEligibleSalary / 100;
    }
  }

  return {
    UC: (retirementRateUC * eligibleSalaryRetirement / 100) + dcSupplementalUC,
    employee: (retirementRateEmployee * eligibleSalaryRetirement / 100) + dcSupplementalEmployee
  };

};

const isSubjectToPepra = (hired_date_tier, lblRehired, hiredBeforeDate, pension_choice) => {
  let result = false;

  if (hired_date_tier === ON_OR_AFTER_JULY_1_2016) {
    result = true;
    if ((lblRehired === YES) && (hiredBeforeDate === YES)) {
      result = false;
    }

    if (lblRehired && (hiredBeforeDate === NO) && (pension_choice === SAVINGS_CHOICE)) {
      result = false;
    }

  }

  return result;
};

const getMedicalOrDentalInsurance = (plan, coverage, payband) => {
  const rates = {
    UC: 0,
    employee: 0
  };

  if (plan && payband && coverage) {
    const { RATES } = RATES_DATA;
    rates.UC = 12 * RATES[plan].UC[payband][coverage];
    rates.employee = 12 * RATES[plan].EMPLOYEE[payband][coverage];
  }

  return rates;
};

const getPayband = salary => Object.keys(RATES_DATA.PAYBANDS).sort()
  .find((pbKey, idx) => Math.floor(salary) <= RATES_DATA.PAYBANDS[pbKey]);

